import '../styles/DigitalForm.css';
import '../styles/Common.css';
import { useState } from 'react';
import { validateDigitalForm } from '../utils/digitalFormValidation';
import { useLocation } from 'react-router-dom';
import { submitDigitalFormApi } from '../api/digital_request_api';
import { FormField, FormSelect } from '../utils/formUtils';
import { buildFormData } from '../utils/buildFormData';

export function DigitalForm() {
    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [newRequestId, setNewRequestId] = useState(null);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    const handleChange = async (e) => {
        const { name, type, files, value } = e.target;
        if (type === 'file') {
            if (files && files.length > 0) {
                setValues(prev => ({
                    ...prev,
                    [name]: Array.from(files)
                }));
            }
        } else {
            setValues((prev) => ({ ...prev, [name]: value }));
        }

        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                if (Object.keys(newErrors).length === 0) setSubmitted(false);
                return newErrors;
            });
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateDigitalForm(values);
        setErrors(validationErrors);
        setSubmitted(true);

        if (!token) {
            alert('קישור לא תקין. לא ניתן לשלוח את הבקשה.');
            return;
        }

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                console.log("submitting form with values:", values);
                const formData = buildFormData(values, token);
                console.log("Built formData:", formData);

                const response = await submitDigitalFormApi(formData);
                console.log("response after submit", response, response.id);
                setNewRequestId(response.id);
                setShowSuccess(true);
                setValues({});
                setSubmitted(false);
                setErrors({});
            } catch (err) {
                console.error('err: ' + err.response?.status);
                if (err.response?.status === 409) {
                    alert('הטופס כבר נשלח. לא ניתן לשלוח אותו שוב.');
                } else {
                    alert('שמירת הבקשה נכשלה: ' + (err.response?.data?.error || ''));
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="digital-form">
            <h1>בקשה לסיוע</h1>
            {showSuccess && (
                <div className="digital-form-success-pop">
                    <div className="digital-form-success-pop-inner">
                        <div className="digital-form-success-title">טופס הבקשה לסיוע נשלח בהצלחה</div>
                        <div className="digital-form-success-btns">
                            <a className="btn digital-form-success-link" href={`/digital-form/view/${newRequestId || ''}`} target="_blank" rel="noopener noreferrer">להצגת הבקשה</a>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleSubmit} noValidate>
                <div className="digital-form-sections">
                    <div className="digital-form-section beneficiary-grid">
                        <h2>פרטי הנתמך</h2>
                        <FormField label="שם פרטי:" name="beneficiaryFirstName" value={values.beneficiaryFirstName || ''} onChange={handleChange} error={submitted && errors.beneficiaryFirstName} />
                        <FormField label="שם משפחה:" name="beneficiaryLastName" value={values.beneficiaryLastName || ''} onChange={handleChange} error={submitted && errors.beneficiaryLastName} />
                        {/* <FormSelect
                            label="סוג מזהה נתמך:"
                            name="beneficiaryIdType"
                            value={values.beneficiaryIdType || 'id'}
                            onChange={handleChange}
                            options={[
                                { value: 'id', label: 'תעודת זהות' },
                                { value: 'passport', label: 'דרכון' }
                            ]}
                        />
                        <FormField
                            label={values.beneficiaryIdType === 'passport' ? "מספר דרכון נתמך:" : "תעודת זהות נתמך:"}
                            name="beneficiaryIdNumber"
                            value={values.beneficiaryIdNumber || ''}
                            onChange={handleChange}
                            error={submitted && errors.beneficiaryIdNumber}
                        /> */}
                        <div className="form-group id-type-group">
                            <label>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span>{values.beneficiaryIdType === 'passport' ? 'מספר דרכון נתמך:' : 'תעודת זהות נתמך:'}</span>
                                    <div className="radio-buttons-inline">
                                        <label className="radio-option">
                                            <input
                                                type="radio"
                                                name="beneficiaryIdType"
                                                value="id"
                                                checked={values.beneficiaryIdType === 'id' || !values.beneficiaryIdType}
                                                onChange={handleChange}
                                            />
                                            <span>ת.ז.</span>
                                        </label>
                                        <label className="radio-option">
                                            <input
                                                type="radio"
                                                name="beneficiaryIdType"
                                                value="passport"
                                                checked={values.beneficiaryIdType === 'passport'}
                                                onChange={handleChange}
                                            />
                                            <span>דרכון</span>
                                        </label>
                                    </div>
                                </div>
                                <input 
                                    type="text"
                                    name="beneficiaryIdNumber"
                                    value={values.beneficiaryIdNumber || ''}
                                    onChange={handleChange}
                                />
                                {submitted && errors.beneficiaryIdNumber && <span className="error-msg">{errors.beneficiaryIdNumber}</span>}
                            </label>
                        </div>
                        <FormField label="כתובת:" name="beneficiaryAddress" value={values.beneficiaryAddress || ''} onChange={handleChange} error={submitted && errors.beneficiaryAddress} />
                        <FormField label="שם האב:" name="beneficiaryFatherName" value={values.beneficiaryFatherName || ''} onChange={handleChange} error={submitted && errors.beneficiaryFatherName} />
                        <FormField label="שם האם:" name="beneficiaryMotherName" value={values.beneficiaryMotherName || ''} onChange={handleChange} error={submitted && errors.beneficiaryMotherName} />
                        <FormField label="טלפון:" name="beneficiaryPhone" value={values.beneficiaryPhone || ''} onChange={handleChange} error={submitted && errors.beneficiaryPhone} />
                        <FormField label="אימייל:" name="beneficiaryEmail" value={values.beneficiaryEmail || ''} onChange={handleChange} error={submitted && errors.beneficiaryEmail} />
                    </div>
                </div>
                {/* סוג התמיכה */}
                <div className="digital-form-section">
                    <h2>תמיכה</h2>
                    <FormSelect
                        label="סוג התמיכה:"
                        name="supportType"
                        value={values.supportType || ''}
                        onChange={handleChange}
                        error={submitted && errors.supportType}
                        options={[
                            { value: '', label: 'בחר' },
                            { value: 'tuition', label: 'שכר לימוד' },
                            { value: 'welfare', label: 'סיוע ורווחה' },
                            { value: 'wedding', label: 'הכנסת כלה' },
                        ]}
                    />
                    {/* שכר לימוד */}
                    {values.supportType === 'tuition' && (
                        <div className="digital-form-support-tuition">
                            <div style={{ margin: '8px 0', fontWeight: 500 }}>נא להעלות טפסים נדרשים (כולל צילום ת.ז.):</div>
                            <input type="file" name="tuitionFiles" multiple onChange={handleChange} />
                        </div>
                    )}
                    {/* סיוע ורווחה */}
                    {values.supportType === 'welfare' && (
                        <div className="digital-form-support-welfare">
                            <FormSelect
                                label="איך תתקבל התמיכה?"
                                name="welfareSupportType"
                                value={values.welfareSupportType || ''}
                                onChange={handleChange}
                                error={submitted && errors.welfareSupportType}
                                options={[
                                    { value: '', label: 'בחר' },
                                    { value: 'direct', label: 'תמיכה ישירה' },
                                    { value: 'caregiver', label: 'תשלום למטפל/ת' },
                                    { value: 'products', label: 'מימון ברכישת מוצרים' },
                                ]}
                            />
                            <FormField
                                label="מספר התמיכות:"
                                name="welfareSupportCount"
                                value={values.welfareSupportCount || ''}
                                onChange={handleChange}
                                error={submitted && errors.welfareSupportCount}
                            />
                            <div style={{ fontWeight: 500, margin: '12px 0 4px 0' }}>למקבלים סיוע רגשי/רפואי:</div>
                            <FormField
                                label="שם מורה מקשרת:"
                                name="caregiverContactName"
                                value={values.caregiverContactName || ''}
                                onChange={handleChange}
                                error={submitted && errors.caregiverContactName}
                            />
                            <FormField
                                label="פלא' מורה מקשרת"
                                name="caregiverContactPhone"
                                value={values.caregiverContactPhone || ''}
                                onChange={handleChange}
                                error={submitted && errors.caregiverContactPhone}
                            />
                        </div>
                    )}
                    {/* הכנסת כלה */}
                    {values.supportType === 'wedding' && (
                        <div className="digital-form-support-wedding">
                            <FormField label="שם החתן:" name="groomName" value={values.groomName || ''} onChange={handleChange} error={submitted && errors.groomName} />
                            <FormField label="ישיבה:" name="yeshiva" value={values.yeshiva || ''} onChange={handleChange} error={submitted && errors.yeshiva} />
                            <FormField label="תאריך החתונה:" name="weddingDate" value={values.weddingDate || ''} onChange={handleChange} error={submitted && errors.weddingDate} type="date" />
                            <FormField label="שם אולם:" name="weddingHall" value={values.weddingHall || ''} onChange={handleChange} error={submitted && errors.weddingHall} />
                        </div>
                    )}
                </div>
                {/* פירוט הסיבה לבקשה */}

                <div className="digital-form-section">
                    <h2>פירוט הסיבה לבקשה</h2>
                    <label htmlFor="requestReason" className="digital-form-label">
                        פירוט הסיבה לבקשה:
                        <textarea id="requestReason" name="requestReason" value={values.requestReason || ''} onChange={handleChange} className="digital-form-textarea" />
                        {submitted && errors.requestReason && <span className="error-msg">{errors.requestReason}</span>}
                    </label>
                    <div style={{ margin: '8px 0', fontWeight: 500 }}>ניתן להעלות מסמכים רלוונטיים:</div>
                    <input type="file" name="reasonFiles" multiple onChange={handleChange} />
                </div>
                {/* אופן התמיכה */}
                <div className="digital-form-section">
                    <h2>אופן התמיכה</h2>
                    <div className="digital-form-radio-group">
                        <label className="radio-rtl">
                            <input
                                type="radio"
                                name="supportPaymentType"
                                value="bank"
                                checked={values.supportPaymentType === 'bank'}
                                onChange={handleChange}
                                required
                            />
                            העברה בנקאית ישירה (לנתמך או להורים)
                        </label>
                        <label className="radio-rtl">
                            <input
                                type="radio"
                                name="supportPaymentType"
                                value="supplier"
                                checked={values.supportPaymentType === 'supplier'}
                                onChange={handleChange}
                                required
                            />
                            תשלום לספק (טיפול רגשי, רפואי, שוברים, מצרכים)
                        </label>
                    </div>
                    {values.supportPaymentType === 'bank' && (
                        <div className="digital-form-bank-row">
                            <FormField label="מספר בנק:" name="bankNumber" value={values.bankNumber || ''} onChange={handleChange} error={submitted && errors.bankNumber} />
                            <FormField label="מספר סניף:" name="branchNumber" value={values.branchNumber || ''} onChange={handleChange} error={submitted && errors.branchNumber} />
                            <FormField label="מספר חשבון:" name="accountNumber" value={values.accountNumber || ''} onChange={handleChange} error={submitted && errors.accountNumber} />
                        </div>
                    )}
                    {values.supportPaymentType === 'supplier' && (
                        <div className="digital-form-supplier-row">
                            <FormField label="שם ספק:" name="supplierName" value={values.supplierName || ''} onChange={handleChange} error={submitted && errors.supplierName} />
                            <FormField label="מס' עוסק פטור (ח.פ.):" name="supplierId" value={values.supplierId || ''} onChange={handleChange} error={submitted && errors.supplierId} />
                            <FormField label="מספר בנק:" name="bankNumber" value={values.bankNumber || ''} onChange={handleChange} error={submitted && errors.bankNumber} />
                            <FormField label="מספר סניף:" name="branchNumber" value={values.branchNumber || ''} onChange={handleChange} error={submitted && errors.branchNumber} />
                            <FormField label="מספר חשבון:" name="accountNumber" value={values.accountNumber || ''} onChange={handleChange} error={submitted && errors.accountNumber} />
                        </div>
                    )}
                </div>
                {/* לפני כפתור שלח בקשה */}
                <div className="digital-form-section digital-form-consent-section">
                    <label className="digital-form-consent-label">
                        <input
                            type="checkbox"
                            name="charityAware"
                            checked={values.charityAware || false}
                            onChange={handleChange}
                            required
                            style={{ width: 18, height: 18, marginLeft: 8 }}
                        />
                        <span>אנו מודעים שהסיוע ניתן מקופת צדקה והינו מיועד לנזקקים לכך בלבד.</span>
                    </label>
                    <div className="digital-form-filler-fields">
                        <FormField label="שם פרטי של ממלא הטופס:" name="fillerFirstName" value={values.fillerFirstName || ''} onChange={handleChange} error={submitted && errors.fillerFirstName} />
                        <FormField label="שם משפחה של ממלא הטופס:" name="fillerLastName" value={values.fillerLastName || ''} onChange={handleChange} error={submitted && errors.fillerLastName} />
                        <FormField label="קרבה לנתמך:" name="fillerRelation" value={values.fillerRelation || ''} onChange={handleChange} error={submitted && errors.fillerRelation} />
                        <FormField label="טלפון ליצירת קשר:" name="fillerPhone" value={values.fillerPhone || ''} onChange={handleChange} error={submitted && errors.fillerPhone} />
                        <FormField label="חתימה:" name="fillerSignature" value={values.fillerSignature || ''} onChange={handleChange} error={submitted && errors.fillerSignature} />
                    </div>
                </div>
                <button className='btn digital-form-submit' type="submit" disabled={isLoading}>
                    {isLoading ? 'שולח...' : 'שלח בקשה'}
                </button>
                {submitted && Object.keys(errors).length > 0 && (
                    <div className="error-msg" style={{ textAlign: 'center', marginTop: 8 }}>
                        יש למלא את כל שדות החובה בצורה תקינה
                    </div>
                )}
            </form>
        </div>
    );
}

export default DigitalForm;